module.exports = __webpack_public_path__ + "img/72600.e4bfc0b5.jpg";